import React, {useEffect} from "react";
import useModel from "../../model/useModel";

// Frontend verze se zapéká do bundlu při buildu (CRA REACT_APP_*); backend
// verzi stahujeme z /version. Když se časy FE/BE rozejdou, běží různé buildy.
const FE_BUILD_TIME = process.env.REACT_APP_BUILD_TIME || 'dev';
const FE_VERSION = process.env.REACT_APP_VERSION || 'dev';

const VersionBadge = () => {
    const {process: loadVersion, state: {result, isSuccess, isFailed}} = useModel((model) => model.version.get);

    useEffect(() => {
        loadVersion();
    }, [loadVersion]);

    const beTime = isSuccess && result ? (result.buildTime || 'dev') : (isFailed ? '?' : '…');
    const beVersion = isSuccess && result ? (result.version || '') : '';

    return (
        <span className="edition-badge">
            <span className="version-line" title={`frontend ${FE_VERSION}`}>FE {FE_BUILD_TIME}</span>
            <span className="version-line" title={`backend ${beVersion}`}>BE {beTime}</span>
        </span>
    );
};

export default VersionBadge;
